// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/private/tmp/pm-file-icons-release-2b4c9d7-workspace/pms-frontend/src/models/breadcrumb';
import model_3 from '/private/tmp/pm-file-icons-release-2b4c9d7-workspace/pms-frontend/src/.umi-production/plugin-initialState/@@initialState';
import model_2 from '/private/tmp/pm-file-icons-release-2b4c9d7-workspace/pms-frontend/src/models/oa-approval';

export const models = {
model_1: { namespace: 'breadcrumb', model: model_1 },
model_3: { namespace: '@@initialState', model: model_3 },
model_2: { namespace: 'oa-approval', model: model_2 },
} as const
